import { checkPermission } from '@/router/guards.ts'

const CustomerModule = () => import('./CustomerModule.vue')
const CustomerIndex = () => import('./views/CustomerIndex.vue')
const CustomerCloseAccountRequestIndex = () =>
  import('./views/CustomerCloseAccountRequestIndex.vue')

export const customerRoute = {
  path: '/customers',
  name: 'customer',
  component: CustomerModule,
  meta: {
    title: 'Customers',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'customers.index',
      component: CustomerIndex,
      meta: {
        permission: 'customer.view',
      },
      beforeEnter: checkPermission('customer.view'),
    },
    {
      path: 'close-account-requests',
      name: 'customer.close_account.index',
      meta: {
        permission: 'customer.view',
      },
      component: CustomerCloseAccountRequestIndex,
      beforeEnter: checkPermission('customer.view'),
    },
  ],
}
